---
import { clsx } from '@digital-spiders/misc-utils';
import { spanToPlainText } from 'astro-portabletext';
import type { Mark, Props as PortableTextProps } from 'astro-portabletext/types';
import type { PageDocumentType } from '../../types/types';
import { getUrlFromVersatileLink } from '../../utils/sanity';
import TextLink from '../ui/TextLink';
import styles from './GenericLinkSerializer.module.scss';

type Props = PortableTextProps<
  Mark<{
    reference: {
      slug: { current: string };
      _type: PageDocumentType;
    };
    anchorLink?: string;
  }>
>;

const { node } = Astro.props;

const linkText = spanToPlainText(node);
let linkSizeClass = styles.smallLink;
if (linkText.length > 20) {
  linkSizeClass = styles.mediumLink;
}
if (linkText.length > 60) {
  linkSizeClass = styles.largeLink;
}
---

<TextLink
  to={getUrlFromVersatileLink({
    pageReference: node.markDef.reference,
    anchorLink: node.markDef.anchorLink,
  })}
  className={clsx(styles.link, linkSizeClass)}><slot /></TextLink
>
